module.exports = __webpack_public_path__ + "static/image/service/pc/one.jpg?e4fe4dce";